export default class Queue {
    constructor(theSize) {
        this.size = theSize + 1;
        this.data = [];
        this.front = 0;
        this.back = 0;
    }

    isEmpty() {
        return this.front === this.back;
    }

    isFull() {
        return (this.back + 1) % this.size === this.front;
    }

    put(value) {
        if (this.isFull()) {
            throw 'Attempt to add to a full Queue.';
        } else {
            this.data[this.back] = value;
            this.back = (this.back + 1) % this.size;
        }
    }

    get() {
        if (this.isEmpty()) {
            throw 'Attempt to get from an empty Queue.';
        } else {
            const value = this.data[this.front];
            this.front = (this.front + 1) % this.size;
            return value;
        }
    }
}